import { Helmet } from "react-helmet-async";

const SITE_URL = "https://wellnesscowgirls.com";

interface PageMetaProps {
  title: string;
  description: string;
  /** Path beginning with "/" — used for canonical and og:url */
  path: string;
  /** Optional JSON-LD object(s) for this page */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
}

/**
 * Per-route head metadata. Titles/descriptions/canonical/og:* are unique per
 * page so search and social platforms stop attributing every route to the
 * homepage copy in index.html.
 */
export function PageMeta({ title, description, path, jsonLd, noindex }: PageMetaProps) {
  const url = `${SITE_URL}${path}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {blocks.map((block, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}

export default PageMeta;
